import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { BreakpointService } from '@big-direkt/utils/shared';

@Component({
    selector: 'big-ui-header',
    templateUrl: './header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[class]': 'classList()',
    },
})
export class HeaderComponent {
    private readonly breakpointService = inject(BreakpointService);

    public readonly scrollPositionY = this.breakpointService.scrollPositionY;

    public readonly centeredTitle = input<string | undefined>(undefined);
    public readonly classList = input('print:hidden');

    public readonly showCenteredTitle = computed(() => {
        const scrollY = this.scrollPositionY();
        const show = scrollY <= this.previousScrollPosition;

        this.previousScrollPosition = scrollY;

        return show;
    });

    private previousScrollPosition = 0;
}
